export default __webpack_public_path__ + "static/media/bannerBig4.647cb20c.png";